import { AuditPage } from '@app/forms/subscription/definition/interface/audit-page';

export const CLIENT_AUDIT_ROUTES: Record<AuditPage, string> = {
  INCOME: '#/dashboard/career',
  LOAN: '#/dashboard/loans',
  REAL_ESTATE: '#/dashboard/estates/overview',
  FINANCIAL: '#/dashboard/assets/overview',
  COMPANIES: '#/dashboard/profile/company',
};

export const AUDIT_PAGE_LABELS: Record<AuditPage, string> = {
  INCOME: 'Revenus',
  LOAN: 'Crédits',
  REAL_ESTATE: 'Immobilier',
  FINANCIAL: 'Financier / Liquidités',
  COMPANIES: 'Actifs professionnels',
};
